import { AfterViewInit, Component, ElementRef, OnInit, Optional, ViewChild } from '@angular/core';
import { NbDialogRef, NbMenuService, NbDialogService } from '@nebular/theme';
import { HomeInputGridComponent } from '../home-input-grid/home-input-grid.component';
import { RendererType, TestimonialLayoutEnum } from '@urbannex/storethemes';
import { TestimononialsInputDialogComponent } from './testimononials-input-dialog/testimononials-input-dialog.component';

@Component({
  selector: 'ngx-home-input-testimonials',
  templateUrl: './home-input-testimonials.component.html',
  styleUrls: ['./home-input-testimonials.component.scss']
})
export class HomeInputTestimonialsComponent implements OnInit, AfterViewInit{
  activeInputMenuItem:string;
  title:string;
  collapsed:boolean = true;

  @ViewChild('expandable',{read:ElementRef}) expandable:ElementRef<HTMLElement>

  constructor(
    @Optional() protected ref: NbDialogRef<HomeInputGridComponent>,
    private menuService:NbMenuService,
    private el:ElementRef<HTMLElement>,
    private dialogService: NbDialogService
    ) { }
  
  ngOnInit(): void {
    this.menuService.onItemClick().subscribe(menuBag =>{
      let selectedItem = menuBag.item;
      if(selectedItem != undefined){
        this.activeInputMenuItem = selectedItem.title;
      }
    })
  }

  ngAfterViewInit():void{
    const overlayPane = this.el.nativeElement.parentElement.parentElement;
    const overlayWrapper = this.el.nativeElement.parentElement.parentElement.parentElement;
    setTimeout(() => {
      overlayWrapper.style.left ="0px";
      overlayWrapper.style.justifyContent = "flex-end";
      overlayWrapper.style.right = "16px";
      //overlayPane.style.width = "256px";
      overlayPane.style.marginRight = "16px";
      overlayPane.style.marginTop = "18px";
      overlayPane.style.display = "block";
    }, 1);


    //return el.parentElement.parentElement.parentElement.parentElement;
  }

  toggleContainer(){
    this.expandable.nativeElement.classList.toggle("collapsed");
  }

  createGrid(numberOfElements){
    const layoutClass = this.getLayoutClass(numberOfElements);

    this.dialogService.open(TestimononialsInputDialogComponent, {
      context:{
        rendererType:RendererType.TESTIMONIALS,
        layoutClass:layoutClass,
        title:"Adding new testimonial section with layout: "+layoutClass
      }
    }).onClose.subscribe(() => {
      console.log("closing")
    })
    this.ref.close();
  }

  getLayoutClass(numberOfCells:number):TestimonialLayoutEnum{
    switch (numberOfCells) {
      case 1:
        return TestimonialLayoutEnum.LAYOUT_1        
        break;
      case 2:
        return TestimonialLayoutEnum.LAYOUT_2
        break;
      case 3:
        return TestimonialLayoutEnum.LAYOUT_3
        break;
      case 3:
        return TestimonialLayoutEnum.LAYOUT_4
        break;
      default:
        return TestimonialLayoutEnum.LAYOUT_1
        break;
    }

  }

  close(e){
    this.ref.close();
  }

}
